import "core-js/modules/es.parse-int";
import { makeEntityScaffold } from '@classpass/saga-tools';
export var venueList = makeEntityScaffold('SAGA.API.VENUES', function (client, options, overrides) {
  return client.venues.getList(options, overrides).then(function (data) {
    return {
      venues: data.venues,
      meta: data.meta ? {
        numPages: data.meta.num_pages,
        currentPage: data.meta.current_page,
        totalCount: data.meta.total_count
      } : {}
    };
  });
});
export var venueListV2 = makeEntityScaffold('SAGA.API.VENUES_V2', function (client, options, overrides) {
  return client.venues.getListV2(options, overrides).then(function (data) {
    return {
      venues: data.venues,
      meta: data.meta ? {
        numPages: data.meta.num_pages,
        currentPage: data.meta.current_page,
        totalCount: data.meta.total_count
      } : {}
    };
  });
});
export var venueByIdV2 = makeEntityScaffold('SAGA.API.VENUE_BY_ID_V2', function (client, venueId, options) {
  return client.venues.getVenueByIdV2(venueId, options);
}, {
  defaultKey: 1
});
export var scheduleForVenue = makeEntityScaffold('SAGA.API.SCHEDULE_FOR_VENUE', function (client, venueId, options) {
  return client.venues.getSchedulesPerVenue(venueId, options).then(function (data) {
    return data.schedules;
  });
}, {
  defaultKey: 1
});
export var similarVenues = makeEntityScaffold('SAGA.API.SIMILAR_VENUES', function (client, venueId, options) {
  return client.venues.getVenueSimilarities(venueId, options).then(function (data) {
    return data.venues;
  });
}, {
  defaultKey: 1
});
export var reviewsForVenue = makeEntityScaffold('SAGA.API.REVIEWS_FOR_VENUE', function (client, venueId) {
  var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 25;
  return client.venues.getVenueReviews(venueId, {
    page_size: perPage,
    page: parseInt(page, 10),
    meta: true
  });
}, {
  defaultKey: [1, 2]
});
export var venueSiblings = makeEntityScaffold('SAGA.API.VENUE_SIBLINGS', function (client, venueId, options) {
  return client.venues.getVenueSiblings(venueId, options);
}, {
  defaultKey: 1
});
export var nearbyPopularVenues = makeEntityScaffold('SAGA.API.NEARBY_POPULAR_VENUES', function (client, msaId, overrides) {
  return client.venues.getNearbyPopularVenue(msaId, overrides).then(function (data) {
    return {
      venues: data.venues,
      meta: data.meta ? {
        numPages: data.meta.num_pages,
        currentPage: data.meta.current_page,
        totalCount: data.meta.total_count
      } : {}
    };
  });
}, {
  defaultKey: 1
});